$(function () {
  $('[data-chat-button]').on('click', function () {
    var message = $('[data-chat-message]').val().trim();

    if (!message) {
      animateEl($('[data-chat-message]'), 'shake');
      return;
    }

    saveChatMessage(message);
  });

  $('[data-chat-message]').on('keypress', function (ev) {
    if (ev.which == 13 && !ev.shiftKey) {
      ev.preventDefault();

      var message = $('[data-chat-message]').val().trim();

      if (!message) {
        animateEl($('[data-chat-message]'), 'shake');
        return;
      }

      saveChatMessage(message);

      return false;
    }
  });
});

function saveChatMessage(message) {
  if (app.savingChatMessage) {
    return false;
  }

  $.ajax({
    url: '/admin/chat/save',
    method: 'post',
    data: {
      message: message
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.savingChatMessage = true;
      $('[data-chat-message], [data-chat-button]').attr('disabled', 'disabled');
    },
    success: function (response) {
      app.savingChatMessage = false;
      $('[data-chat-message], [data-chat-button]').removeAttr('disabled');
      if (response && response.success) {
        $('[data-chat-message]').val('');
        $('[data-chat-message]').removeAttr('style').val('');
        addChatMessage(response);
        return;
      }
      animateEl($('[data-chat-button]'), 'shake');
      error();
    },
    error: function () {
      $('[data-chat-message], [data-chat-button]').removeAttr('disabled');
      animateEl($('[data-chat-button]'), 'shake');
      app.savingChatMessage = false;
      ajaxError();
    }
  });
}

function addChatMessage(response) {
  var wrapperEl = getChatMessageHTML(response);
  wrapperEl.css({ display: 'none' });

  // Append
  $('[data-chat-messages]').prepend(wrapperEl);
  wrapperEl.slideDown(250);

  // Remove
  var limit = $('[data-chat-limit]').attr('data-chat-limit');
  $(
    '[data-chat-messages] .chat__message:nth-child(n+' +
      (parseInt(limit) + 1) +
      ')'
  ).slideUp(250, function () {
    $(this).remove();
  });
}

function getChatMessageHTML(data) {
  // Wrapper
  var wrapperEl = $('<div class="chat__message"/>');
  wrapperEl.attr('data-chat-id', data.item.id);

  // Header
  var headerEl = $('<div class="chat__message-header"/>');
  headerEl.appendTo(wrapperEl);

  var userEl = $('<div class="chat__message-user"/>');
  userEl.html(data.item.created_by_user.title);
  userEl.appendTo(headerEl);

  var editEl = $('<div class="chat__message-edit"/>');
  editEl.html(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z"></path></svg>'
  );
  editEl.on('click', function () {
    editChatMessage(data.item.id);
  });
  editEl.appendTo(headerEl);

  var dateEl = $('<div class="chat__message-date"/>');
  dateEl.html(data.date);
  dateEl.appendTo(headerEl);

  // Message
  var messageEl = $('<div class="chat__message-text"/>');
  messageEl.html(data.item.text);
  messageEl.appendTo(wrapperEl);

  return wrapperEl;
}

function loadMoreChatMessages() {
  if (app.loadingMoreChatMessages) {
    return false;
  }

  var lastId = $('.chat__messages .chat__message:last-child').attr(
    'data-chat-id'
  );

  if (!lastId) {
    error();
    return;
  }

  $.ajax({
    url: '/admin/chat/load',
    method: 'post',
    data: {
      lastId: lastId
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.loadingMoreChatMessages = true;
      $('[data-chat-load-more]').attr('disabled', 'disabled');
    },
    success: function (response) {
      app.loadingMoreChatMessages = false;
      $('[data-chat-load-more]').removeAttr('disabled');
      if (response && response.success) {
        if (!response.success) {
          error();
          return;
        }

        $.each(response.chats, function (index, item) {
          var messageHTML = getChatMessageHTML(item);
          messageHTML.appendTo($('.chat__messages'));
        });

        if (!response.hasMore) {
          $('[data-chat-load-more]').remove();
          $('<div class="chat__message-all-loaded"/>')
            .html('Alle Nachrichten geladen')
            .appendTo($('.chat__wrapper'));
        }
        return;
      }
      animateEl($('[data-chat-load-more]'), 'shake');
      error();
    },
    error: function () {
      $('[data-chat-load-more]').removeAttr('disabled');
      animateEl($('[data-chat-load-more]'), 'shake');
      app.loadingMoreChatMessages = false;
      ajaxError();
    }
  });
}

function editChatMessage(id) {
  if (!app.editChatMessageModal) {
    app.editChatMessageModal = new jBox('Modal', {
      addClass: 'modal__wrapper',
      adjustDistance: 16,
      closeButton: 'title',
      width: 480,
      title: 'Nachricht bearbeiten',
      content: '',
      createOnInit: true,
      zIndex: 11000,
      onCreated: function () {
        // Fix close button
        setModalCloseButton(this.wrapper);
      }
    });
  }

  var contentHTML = '';
  contentHTML += '<div class="chat__edit-modal-content-container">';
  contentHTML += '  <div class="chat__edit-modal-content">';
  // prettier-ignore
  contentHTML += '    <textarea rows="5" class="chat__edit-modal-textarea textarea" placeholder="Nachricht eingeben..."></textarea>';
  contentHTML += '  </div>';
  contentHTML += '  <div class="modal-edit-chat__buttons-wrapper">';
  contentHTML += '    <div class="modal-edit-chat__buttons-container">';
  // prettier-ignore
  contentHTML += '      <button class="button button--block button--light modal-edit-chat__delete-button">Löschen</button>';
  contentHTML += '    </div>';
  contentHTML += '    <div class="modal-edit-chat__buttons-container">';
  // prettier-ignore
  contentHTML += '      <button class="button button--block modal-edit-chat__submit-button">Speichern</button>';
  contentHTML += '    </div>';
  contentHTML += '  </div>';
  contentHTML += '</div>';

  app.editChatMessageModal.setContent(contentHTML);

  app.editChatMessageModal.content
    .find('.modal-edit-chat__delete-button')
    .on('click', function () {
      deleteChatMessage(id);
    });

  app.editChatMessageModal.content
    .find('.modal-edit-chat__submit-button')
    .on('click', function () {
      saveEditedChatMessage(id);
    });

  var message = striptags(
    $('.chat__message[data-chat-id="' + id + '"] .chat__message-text').html()
  ).trim();
  app.editChatMessageModal.content
    .find('.chat__edit-modal-textarea')
    .val(message);

  app.editChatMessageModal.open();
}

function disableChatModalForm() {
  if (!app.editChatMessageModal) {
    return;
  }
  app.editChatMessageModal.content
    .find('textarea, button')
    .attr('disabled', 'disabled');
}

function enableChatModalForm() {
  if (!app.editChatMessageModal) {
    return;
  }
  app.editChatMessageModal.content
    .find('textarea, button')
    .removeAttr('disabled');
}

function deleteChatMessage(id) {
  if (app.deletingChatMessage) {
    return false;
  }

  $.ajax({
    url: '/admin/chat/delete',
    method: 'post',
    data: {
      id: id
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.deletingChatMessage = true;
      disableChatModalForm();
    },
    success: function (response) {
      app.deletingChatMessage = false;
      enableChatModalForm();
      if (response && response.success) {
        $('.chat__message[data-chat-id="' + id + '"]').fadeOut(
          500,
          function () {
            $(this).remove();
          }
        );
        app.editChatMessageModal.close();
        success('Nachricht gelöscht');
        return;
      }
      animateEl(
        app.editChatMessageModal.content.find(
          '.modal-edit-chat__delete-button'
        ),
        'shake'
      );
      error();
    },
    error: function () {
      enableChatModalForm();
      animateEl(
        app.editChatMessageModal.content.find(
          '.modal-edit-chat__delete-button'
        ),
        'shake'
      );
      app.deletingChatMessage = false;
      ajaxError();
    }
  });
}

function saveEditedChatMessage(id) {
  if (app.savingEditedChatMessage) {
    return false;
  }

  var message = app.editChatMessageModal.content
    .find('.chat__edit-modal-textarea')
    .val()
    .trim();

  if (!message) {
    animateEl(
      app.editChatMessageModal.content.find('.modal-edit-chat__submit-button'),
      'shake'
    );
  }

  $.ajax({
    url: '/admin/chat/save',
    method: 'post',
    data: {
      id: id,
      message: message
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.savingEditedChatMessage = true;
      disableChatModalForm();
    },
    success: function (response) {
      app.savingEditedChatMessage = false;
      enableChatModalForm();
      if (response && response.success) {
        $('.chat__message[data-chat-id="' + id + '"] .chat__message-text').html(
          response.item.text
        );
        app.editChatMessageModal.close();
        success('Änderungen gespeichert');
        return;
      }
      animateEl(
        app.editChatMessageModal.content.find(
          '.modal-edit-chat__submit-button'
        ),
        'shake'
      );
      error();
    },
    error: function () {
      enableChatModalForm();
      animateEl(
        app.editChatMessageModal.content.find(
          '.modal-edit-chat__submit-button'
        ),
        'shake'
      );
      app.deletingChatMessage = false;
      ajaxError();
    }
  });
}
